import React, { useEffect, useState } from 'react';
import { ChevronUp } from 'lucide-react';

const FloatingActionButtons = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 250);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed bottom-5 right-5 z-50 flex flex-col gap-3">
      {showScrollTop ? (
        <button
          type="button"
          onClick={scrollToTop}
          /* --- Updated Classes Below --- */
          className="flex h-12 w-12 items-center justify-center rounded-full bg-[#1E4363] text-white shadow-xl transition-all duration-300 hover:bg-[#87412A] hover:-translate-y-1 hover:shadow-2xl"
          aria-label="Scroll to top"
          title="Scroll to top"
        >
          <ChevronUp size={24} strokeWidth={2.5} />
        </button>
      ) : null}
    </div>
  );
};

export default FloatingActionButtons;